import React from 'react';
import TeamReviewLayoutDesktop from '../../components/teamReviewComponents/TeamReviewLayoutDesktop';
import { t } from '../../content';

function TeamReview() {
  let openPositionsData = true;

  return (
      <div className="team-review-page">
          {openPositionsData ?
          <div className="team-review-page-wrapper">
              <TeamReviewLayoutDesktop />
          </div>
          : t('emptyStates.noData')}
      </div>
  )


}

export default TeamReview
